export type UserPropertiesSubscription = {
  subscription_type: 'free connect' | 'connect' | 'connect with seats' | 'none';
  subscription_status:
    | 'active'
    | 'trialing'
    | 'past_due'
    | 'canceled'
    | 'unpaid'
    | 'incomplete'
    | 'none';
  subscription_payment_interval: 'monthly' | 'annually' | 'biennial' | 'none';
  subscription_role: 'owner' | 'member' | 'none';
};

export const ComponentLocations = {
  APP_CONTAINER: 'app container',
  FRONT_PAGE: {
    DASHBOARD: 'front page dashboard',
    HERO: 'front page hero',
    LEARNING_CONTENT: 'front page learning content',
    METHODS_CARD: 'front page methods card',
    CONVERT_TO_NOTEBOOK_CARD: 'front page convert to notebook card',
    CONVERT_TO_NOTEBOOK_CARD_IMAGE: 'front page convert to notebook card image',
    SETUP_PROCESS: 'front page setup process',
    DROP_ZONE: 'front page file drop zone',
    APPS_AND_EXTENSIONS: 'front page apps and extensions',
    PASSCODE_RESET: 'front page passcode reset',
    MEETING_NOTES_CARD: 'front page meeting notes card',
  },
  MENU: {
    HEADER_HAMBURGER_MENU: 'header hamburger menu',
    SIDE_MENU: 'side menu',
  },
  FOOTER: {
    FAQ: 'footer FAQ',
    COOKIE_POLICY: 'footer cookie policy',
    NEWS_AND_INFO: 'footer news and info',
    LEGAL: 'footer legal',
  },
  HEADER: {
    MAIN: 'header',
    USER_MENU: 'header user menu',
  },
  CHECKOUT: {
    CONNECT_CHECKOUT: 'connect checkout',
    CONFIRMATION: 'connect checkout confirmation',
    LANDING: 'connect checkout landing',
    LANDING_BOTTOM: 'connect checkout landing bottom',
    CONNECT_OFFER_LANDING_MAIN: 'connect offer landing main',
    CONNECT_OFFER_LANDING_BOTTOM: 'connect offer landing bottom',
    DM_OFFER_LANDING_MAIN: 'dm offer landing main',
    DM_OFFER_LANDING_BOTTOM: 'dm offer landing botom',
    CONTINUE: 'connect checkout continue',
    EDIT: 'connect checkout edit contact details',
  },
  SETUP: {
    DOWNLOAD_APPS: 'setup download apps',
    SETUP_COMPLETE: 'setup complete',
  },
  CONNECT: {
    PROMO: 'connect promotion page',
    SUBSCRIBE_HERO: 'subscribe to connect hero',
    MANAGE_CONNECT_NOTIFICATION: 'manage connect notification',
    NO_ACTIVE_SUBSCRIPTION_CARD: 'no active subscription card',
  },
  MANAGE_CONNECT: {
    MAIN: 'manage connect',
    PAYMENT_INTERVAL_MODAL: 'manage connect payment interval modal',
    SUBSCRIPTION_PAGE: 'manage connect subscription page',
    PAYMENT_PAGE: 'manage connect payment page',
    MEMBERS_PAGE: 'manage connect members page',
  },
  CONNECT_WITH_SEATS: {
    INVITATION_MEMBER_PAGE: 'connect with seats invitation member page',
  },
  SURVEY: {
    ANSWER: 'survey answer',
  },
  DEVICE: {
    READ_ON_REMARKABLE: 'device app read on remarkable',
    DEVICE: 'device app paper tablet',
    APPS: 'device app apps',
  },
  ACCOUNT: {
    BILLING_INFO: 'account billing info',
    CONTACT_DETAILS: 'account contact details',
    SECURITY_CARD: 'account security card',
    DELETION: 'account deletion card',
    MIGRATE_LEGACY: 'account migrate from legacy page',
    MIGRATE_SAML: 'account migrate from saml page',
    MIGRATE_CONFIRM: 'account migrate confirm page',
  },
  SUBSCRIPTION_CARD: {
    MAIN: 'subscription card',
  },
  SUBSCRIPTION: {
    MEMBERS_PAGE: 'subscription members page',
    PLAN_PAGE: 'subscription plan page',
    PAYMENT_PAGE: 'subscription payment page',
    MEMBERS_BULK_ACTIONS: 'subscription members bulk actions',
  },
  NEWS_MODULE: {
    MOBILE_AND_DESKTOP_NOTETAKING: 'news module mobile and desktop notetaking',
    INTRODUCING_TYPE_FOLIO: 'news module introducing type folio',
  },
  FAQ: {
    MAIN: 'FAQ',
  },
  EXPLORE: {
    REMARKABLE_APPLICATIONS: 'explore remarkable applications',
    REMARKABLE_INTEGRATIONS: 'explore remarkable integrations',
    REMARKABLE_EXTENSIONS: 'explore remarkable extensions',
  },
  NOTIFICATIONS: {
    FRONT_PAGE: 'front page notification',
    ACCOUNT_PAGE: 'account page notification',
    UPDATE_PAYMENT_CARD: 'update payment card notification',
  },
  ERROR_MODULES: {
    SOMETHING_WENT_WRONG: 'something went wrong module',
  },
  OPEN_PAGES: {
    DOWNLOAD_MOBILE_APP: 'open download mobile app page',
  },
  FLEET: {
    FLEET_MEMBERS_TABLE: 'fleet members table',
  },
  MRF_MODAL: {
    MRF_MODAL: 'mrf modal',
    MRF_STEP_1: 'mrf step 1',
    MRF_STEP_2: 'mrf step 2',
    MRF_STEP_3: 'mrf step 3',
    MRF_STEP_4: 'mrf step 4',
    MRF_STEP_5: 'mrf step 5',
  },
  ENTERPRISE: {
    VALUE_PROP_PAGE: 'enterprise value prop page',
    MEMBERS_PAGE: 'enterprise members page',
    MEMBERS_PAGE_MOBILE: 'enterprise members page mobile',
    MEMBERS_BULK_ACTIONS: 'enterprise members bulk actions',
    ENROLL_SETUP: 'enterprise enroll setup',
    ENROLL_VERIFY_SAML: 'enterprise enroll verify saml',
    ENROLL_ORGANIZATION: 'enterprise enroll organization',
    ENROLL_DOMAIN: 'enterprise enroll setup domain',
    ENROLL_SETUP_SAML: 'enterprise enroll setup saml',
    ENROLL_COMPLETE: 'enterprise enroll complete',
    ACCOUNT_LINKING_MISMATCH: 'enterprise account linking mismatch page',
    BILLING_PAGE: 'enterprise billing page',
    DEVICES_PAGE: 'enterprise devices page',
    DEVICES_BULK_ACTIONS: 'enterprise devices bulk actions',
    DOMAINS_PAGE: 'enterprise domains page',
    POLICIES_PAGE: 'enterprise policies page',
    SETTINGS_PAGE: 'enterprise settings page',
    MODAL_SWITCH_TO_ANNUAL: 'enterprise modal switch to annual plan',
    MODAL_SWITCH_TO_MONTHLY: 'enterprise modal switch to monthly plan',
  },
  INTEGRATIONS: {
    PROVIDER_ITEM: 'integrations provider item',
    PROVIDER_LIST: 'integrations provider list',
    ACTIVE_INTEGRATION_ITEM: 'integrations active integration item',
    TERMS_OF_SERVICE: 'integrations terms of service',
  },
  PAIR: {
    APP: 'pair app',
  },
  MY_FILES: {
    DROP_ZONE: 'my files file drop zone',
    HEADER: 'my files header',
  },
} as const;

export const CHECKOUT_STEPS = {
  CHECKOUT_PROCESS_STARTED: 'Successfully started checkout process',
  BILLING_INFORMATION_VALIDATED: 'Billing information validated',
  // Checkout V2 (cloud-connect)
  CHECKOUT_V2_STARTED: 'Checkout V2 started',
  CHECKOUT_V2_CONTACT_DETAILS_COMPLETED:
    'Checkout V2 contact details completed',
  CHECKOUT_V2_PROMOTION_APPLIED: 'Checkout V2 promotion applied',
  CHECKOUT_V2_PROMOTION_FAILED: 'Checkout V2 promotion failed',
} as const;
